import { useNewRelic } from '@/composables/useNewRelic';
import { TutorialGuidanceService } from '@/services/tutorial-guidance.service';
import { UsersService } from '@/services/users.service';
import { useTutorialGuidanceStore } from '@/stores/tutorial-guidance';
import { useUserStore } from '@/stores/user';

const usersService = new UsersService();
const tutorialGuidanceService = new TutorialGuidanceService();

export function useTutorialGuidanceData() {
  const tutorialStore = useTutorialGuidanceStore();
  const userStore = useUserStore();
  const newRelic = useNewRelic();

  const fetchUnviewedGuidance = async () => {
    try {
      const guidances = (await tutorialGuidanceService.getUnviewedGuidance(userStore.selectedAccountId))?.model;
      tutorialStore.updateFetched(true);
      if (Array.isArray(guidances) && guidances.length > 0) {
        tutorialStore.updateGuidances(guidances);
      }
    } catch (error) {
      newRelic.noticeError(error as Error, {
        message: 'Failed to fetch tutorial guidance',
        userId: userStore.userProfile?.profile?.id,
      });
    }
  };

  const completeCurrentGuidance = async (guidanceId: string) => {
    const guidanceIdx = tutorialStore.guidances.findIndex((guidance) => guidance._id === guidanceId);
    if (guidanceIdx !== -1) {
      try {
        await usersService.updateTutorialGuidanceViewed(guidanceId);
        tutorialStore.removeGuidance(guidanceIdx);
      } catch (error) {
        newRelic.noticeError(error as Error, {
          message: 'Failed to update tutorial guidance as viewed',
          userId: userStore.userProfile?.profile?.id,
        });
      }
    }
  };

  return { fetchUnviewedGuidance, completeCurrentGuidance };
}
